module.exports = __webpack_public_path__ + "static/media/down-arrow.f6baa07d.svg";